/* Selector file rule: root-level functions in this file must be exported selectors only. Move helper functions to lib files. */
import { createSelector } from 'reselect';
import { NON_RUNNING_RUN_STATES } from '@/lib/pieveRunState.js';
import getNormalizedThreadId from '@/redux/selectors/pieveSelectors/lib/getNormalizedThreadId.js';
import getThreadActiveRunIdValue from '@/redux/selectors/pieveSelectors/lib/getThreadActiveRunIdValue.js';
import getThreadRunStateValue from '@/redux/selectors/pieveSelectors/lib/getThreadRunStateValue.js';
import { activeThreadContent, activeThreadMeta, threadContent, threadMeta } from '@/redux/selectors/pieveSelectors/threadCoreSelectors.js';

export const activeThreadRunId = createSelector([activeThreadContent, activeThreadMeta], (threadContentValue, threadMetaValue) => {
  return getThreadActiveRunIdValue({
    threadContentValue,
    threadMetaValue
  });
});

export const threadRunState = (state, threadId) => {
  const safeThreadId = getNormalizedThreadId(threadId);

  if (!safeThreadId) {
    return 'idle';
  }

  return getThreadRunStateValue({
    threadContentValue: threadContent(state, safeThreadId),
    threadMetaValue: threadMeta(state, safeThreadId)
  });
};

export const threadActiveRunId = (state, threadId) => {
  const safeThreadId = getNormalizedThreadId(threadId);

  if (!safeThreadId) {
    return null;
  }

  return getThreadActiveRunIdValue({
    threadContentValue: threadContent(state, safeThreadId),
    threadMetaValue: threadMeta(state, safeThreadId)
  });
};

export const isThreadRunning = (state, threadId) => {
  const safeThreadId = getNormalizedThreadId(threadId);

  if (!safeThreadId) {
    return false;
  }

  return !NON_RUNNING_RUN_STATES.has(threadRunState(state, safeThreadId));
};

export const activeThreadLatestRunPerf = createSelector([activeThreadContent, activeThreadMeta], (contentValue, metaValue) => {
  return contentValue?.runState?.meta?.perf || metaValue?.runState?.meta?.perf || null;
});

export const threadRunStartedAt = (state, threadId) => {
  const safeThreadId = getNormalizedThreadId(threadId);

  if (!safeThreadId) {
    return null;
  }

  const contentValue = threadContent(state, safeThreadId);
  const metaValue = threadMeta(state, safeThreadId);
  const raw = contentValue?.runState?.startedAt || metaValue?.runState?.startedAt || null;

  if (!raw) {
    return null;
  }

  const ms = typeof raw === 'number' ? raw : Date.parse(raw);

  return Number.isFinite(ms) ? ms : null;
};
